import React from 'react';

import { usePatchCard } from '@vlabs/api/point-api/client';
import { EditIcon } from '@vlabs/icons';
import { useModal } from '@vlabs/uikit';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import { toast } from 'react-toastify';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { EditCardUserDataForm } from './edit-card-user-data-form/EditCardUserDataForm';
import { useEditCardUserDataTranslation } from './i18n';
import type { EditCardUserDataProps } from './types';

type EditCardUserDataIconButtonProps = EditCardUserDataProps & IconButtonProps;

const displayName = 'EditCardUserDataIconButton';
const testid = buildTestid(displayName);

function EditCardUserDataIconButton({
  cardId,
  'data-testid': dataTestId = undefined,
  ...props
}: EditCardUserDataIconButtonProps): JSX.Element {
  const { t } = useEditCardUserDataTranslation();
  const modal = useModal();
  const patchCard = usePatchCard({
    mutation: {
      onSuccess: () => {
        toast.success(t('toast_success'));
        modal.close();
      },
    },
  });

  return (
    <React.Fragment>
      {modal.wrap(<EditCardUserDataForm
        cardId={cardId}
        onCancel={modal.close}
        onSubmit={(userData) => {
          patchCard.mutate({
            cardId,
            data: { user_data: userData },
          });
        }}
      />)}

      <IconButton
        icon={<EditIcon />}
        kind="secondary"
        onClick={modal.open}
        variant="filled"
        {...testid(dataTestId)}
        {...props}
      />
    </React.Fragment>
  );
}

EditCardUserDataIconButton.displayName = displayName;

export { EditCardUserDataIconButton };
